document.addEventListener('DOMContentLoaded', () => {
  const mobileQuery = window.matchMedia('(max-width: 989px)');
  let ajaxinateInstance;
  let reinitTimer;
  let visibilityRaf;
  let filterDrawerScrollX = null;
  let filterDrawerScrollY = null;

  const getSortSelect = () => document.querySelector('#FacetSortForm select[name="sort_by"]');

  const closeDesktopSortDropdown = (wrapper) => {
    wrapper.classList.remove('is-open');
    const button = wrapper.querySelector('.lux-sort__button');
    if (button) button.setAttribute('aria-expanded', 'false');
  };

  const syncSortUIFromSelect = () => {
    const select = getSortSelect();
    if (!select) return;

    const selectedOption = select.options[select.selectedIndex];
    const selectedValue = select.value;
    const selectedLabel = selectedOption ? selectedOption.textContent.trim() : '';

    document.querySelectorAll('.lux-sort__value').forEach((node) => {
      node.textContent = selectedLabel;
    });

    document.querySelectorAll('.lux-sort__option').forEach((node) => {
      node.classList.toggle('is-active', node.dataset.value === selectedValue);
    });

    document.querySelectorAll('[data-mobile-sort-option]').forEach((node) => {
      node.classList.toggle('is-active', node.dataset.value === selectedValue);
    });
  };

  const submitFacets = (searchParams) => {
    if (typeof FacetFiltersForm !== 'undefined' && typeof FacetFiltersForm.renderPage === 'function') {
      FacetFiltersForm.renderPage(searchParams, null);
      return;
    }

    const query = searchParams ? `?${searchParams}` : '';
    window.location.href = `${window.location.pathname}${query}`;
  };

  const collectSearchParams = ({ includeFilters = true, includeSort = true } = {}) => {
    const params = new URLSearchParams();

    if (includeFilters) {
      const filterForm = document.getElementById('FacetFiltersForm');
      if (filterForm) {
        const filterData = new FormData(filterForm);
        for (const [key, val] of filterData.entries()) {
          params.append(key, val);
        }
      }
    }

    if (includeSort) {
      const sortSelect = getSortSelect();
      if (sortSelect && sortSelect.value) {
        params.set('sort_by', sortSelect.value);
      }
    }

    return params.toString();
  };

  const openSortDrawer = () => {
    const drawer = document.querySelector('[data-sort-drawer]');
    if (!drawer) return;

    drawer.hidden = false;
    requestAnimationFrame(() => {
      drawer.classList.add('is-open');
      document.body.classList.add('lux-sort-drawer-open');
    });
  };

  const closeSortDrawer = (immediate = false) => {
    const drawer = document.querySelector('[data-sort-drawer]');
    if (!drawer || drawer.hidden) return;

    if (immediate) {
      drawer.classList.remove('is-open');
      drawer.hidden = true;
      document.body.classList.remove('lux-sort-drawer-open');
      return;
    }

    drawer.classList.remove('is-open');
    document.body.classList.remove('lux-sort-drawer-open');

    const handleEnd = () => {
      drawer.hidden = true;
      drawer.removeEventListener('transitionend', handleEnd);
    };

    drawer.addEventListener('transitionend', handleEnd);
  };

  const applySortValue = (newValue) => {
    const select = getSortSelect();
    if (!select || !newValue || newValue === select.value) {
      closeSortDrawer();
      return;
    }

    select.value = newValue;

    // Trigger Dawn facets refresh.
    select.dispatchEvent(new Event('input', { bubbles: true }));
    select.dispatchEvent(new Event('change', { bubbles: true }));

    syncSortUIFromSelect();
    closeSortDrawer();
  };

  const openFilterDrawer = () => {
    const menuDrawer = document.querySelector(
      '.lux-mobile-filter-slot .mobile-facets__wrapper, .lux-sidebar .mobile-facets__wrapper'
    );
    if (!menuDrawer) return;

    const details = menuDrawer.querySelector('.mobile-facets__disclosure');
    const summary = menuDrawer.querySelector('.mobile-facets__open-wrapper');
    if (!details || !summary) return;

    // If already open, don't retrigger and disturb scroll position.
    if (details.hasAttribute('open')) return;

    const scrollX = window.pageXOffset || document.documentElement.scrollLeft || 0;
    const scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    filterDrawerScrollX = scrollX;
    filterDrawerScrollY = scrollY;

    const focusTarget =
      details.querySelector('.mobile-facets__close, .mobile-facets__close-button, button, [href], input, select') ||
      summary;

    if (typeof menuDrawer.openMenuDrawer === 'function') {
      details.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
      menuDrawer.openMenuDrawer(focusTarget);
    } else {
      summary.click();
    }

    requestAnimationFrame(() => window.scrollTo(scrollX, scrollY));
  };

  const restoreFilterScrollPosition = () => {
    if (filterDrawerScrollY === null) return;
    const x = filterDrawerScrollX || 0;
    const y = filterDrawerScrollY;
    window.scrollTo(x, y);
  };

  const bindFilterDrawerScrollFix = () => {
    const menuDrawer = document.querySelector(
      '.lux-mobile-filter-slot .mobile-facets__wrapper, .lux-sidebar .mobile-facets__wrapper'
    );
    if (!menuDrawer || menuDrawer.dataset.luxFilterScrollFixBound === 'true') return;

    const details = menuDrawer.querySelector('.mobile-facets__disclosure');
    if (!details) return;

    menuDrawer.dataset.luxFilterScrollFixBound = 'true';

    details.addEventListener('toggle', () => {
      if (details.open) return;
      requestAnimationFrame(restoreFilterScrollPosition);
      setTimeout(restoreFilterScrollPosition, 120);
      setTimeout(restoreFilterScrollPosition, 460);
    });
  };

  const syncMobileFilterPlacement = () => {
    const slot = document.querySelector('.lux-mobile-filter-slot');
    const sidebar = document.querySelector('.lux-sidebar');
    const mobileWrapper = document.querySelector(
      '.lux-sidebar .mobile-facets__wrapper, .lux-mobile-filter-slot .mobile-facets__wrapper'
    );

    if (!slot || !sidebar || !mobileWrapper) return;

    const desktopFacetsForm = sidebar.querySelector('.facets.small-hide');

    if (mobileQuery.matches) {
      if (mobileWrapper.parentElement !== slot) {
        slot.appendChild(mobileWrapper);
      }
      sidebar.classList.add('lux-sidebar--mobile-mounted');
      return;
    }

    if (mobileWrapper.parentElement === slot) {
      if (desktopFacetsForm) {
        sidebar.insertBefore(mobileWrapper, desktopFacetsForm);
      } else {
        sidebar.appendChild(mobileWrapper);
      }
    }

    sidebar.classList.remove('lux-sidebar--mobile-mounted');
  };

  const initDesktopSortDropdown = () => {
    const wrappers = document.querySelectorAll('[data-sort]');
    wrappers.forEach((wrapper) => {
      if (wrapper.dataset.sortBound === 'true') return;
      wrapper.dataset.sortBound = 'true';

      const button = wrapper.querySelector('.lux-sort__button');
      const list = wrapper.querySelector('.lux-sort__list');
      const select = wrapper.closest('.lux-sort__form')?.querySelector('select');

      if (!button || !list || !select) return;

      button.addEventListener('click', (event) => {
        event.preventDefault();

        const isOpen = wrapper.classList.contains('is-open');
        document.querySelectorAll('[data-sort].is-open').forEach((item) => {
          closeDesktopSortDropdown(item);
        });

        if (!isOpen) {
          wrapper.classList.add('is-open');
          button.setAttribute('aria-expanded', 'true');
        }
      });

      list.addEventListener('click', (event) => {
        const option = event.target.closest('.lux-sort__option');
        if (!option) return;

        const newValue = option.dataset.value;
        if (!newValue || newValue === select.value) {
          closeDesktopSortDropdown(wrapper);
          return;
        }

        select.value = newValue;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));

        syncSortUIFromSelect();
        closeDesktopSortDropdown(wrapper);
      });
    });
  };

  const stopInfiniteScroll = () => {
    if (ajaxinateInstance && typeof ajaxinateInstance.destroy === 'function') {
      ajaxinateInstance.destroy();
    }
    ajaxinateInstance = undefined;
  };

  const initInfiniteScroll = () => {
    // If the existing instance is still valid and attached to the active DOM, do not recreate it.
    if (
      ajaxinateInstance &&
      document.body.contains(ajaxinateInstance.containerElement) &&
      document.body.contains(ajaxinateInstance.paginationElement)
    ) {
      return;
    }

    stopInfiniteScroll();

    const grid = document.querySelector('#product-grid');
    const nextPage = document.querySelector('.infinite_next');

    if (grid && nextPage && nextPage.querySelector('a') && typeof Ajaxinate !== 'undefined') {
      ajaxinateInstance = new Ajaxinate({
        container: '#product-grid',
        pagination: '.infinite_next',
        method: 'scroll'
      });
    }
  };

  const updateFloatingControlsVisibility = () => {
    const toolbar = document.querySelector('.lux-toolbar');
    const controls = document.querySelector('[data-mobile-floating-controls]');

    if (!toolbar || !controls) return;

    if (!mobileQuery.matches) {
      controls.hidden = true;
      controls.classList.remove('is-visible');
      return;
    }

    const shouldShow = toolbar.getBoundingClientRect().bottom < 0;
    controls.hidden = !shouldShow;
    controls.classList.toggle('is-visible', shouldShow);
  };

  const scheduleFloatingControlsVisibility = () => {
    if (visibilityRaf) cancelAnimationFrame(visibilityRaf);
    visibilityRaf = requestAnimationFrame(updateFloatingControlsVisibility);
  };


  // ── Sort all products: in-stock first, out-of-stock last ───────────────────
  // All products are rendered server-side (paginate by 250), so we just
  // reorder the existing DOM nodes — no AJAX or fetch needed.
  const sortProductsByAvailability = () => {
    const grid = document.querySelector('#product-grid');
    if (!grid) return;

    const items = Array.from(grid.querySelectorAll('.lux-grid__item'));
    if (items.length === 0) return;

    // Check if already in correct order — if yes, skip DOM manipulation entirely.
    // This prevents the MutationObserver from firing in a loop (which causes hover jitter).
    let alreadySorted = true;
    let seenOutOfStock = false;
    for (const item of items) {
      const available = item.dataset.available === 'true';
      if (seenOutOfStock && available) { alreadySorted = false; break; }
      if (!available) seenOutOfStock = true;
    }
    if (alreadySorted) return;

    const inStock = items.filter(el => el.dataset.available === 'true');
    const outOfStock = items.filter(el => el.dataset.available !== 'true');

    const frag = document.createDocumentFragment();
    [...inStock, ...outOfStock].forEach((el, i) => {
      el.style.setProperty('--animation-order', i + 1);
      frag.appendChild(el);
    });

    grid.appendChild(frag);
  };


  // ── Load every product of the collection, in-stock first ─────────────────────
  // Shopify renders at most 250 products per page, so the first 250 come with the page.
  // All the other pages are fetched in the background right away (no scrolling needed),
  // all at the same time, and added in page order. In-stock products are always placed
  // above the first out-of-stock one, so the final order is: all in-stock, then out-of-stock.
  let luxLoader = null;

  const isCurrentLoader = (state) => luxLoader === state && document.body.contains(state.grid);

  const fetchProductPage = async (state, page) => {
    const params = new URLSearchParams(state.params);
    params.set('page', String(page));
    params.set('section_id', state.sectionId);
    let lastError;
    for (let attempt = 0; attempt < 3; attempt++) {
      try {
        const response = await fetch(window.location.pathname + '?' + params.toString(), { credentials: 'same-origin' });
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return new DOMParser().parseFromString(await response.text(), 'text/html');
      } catch (error) {
        lastError = error;
        await new Promise((resolve) => setTimeout(resolve, 800 * (attempt + 1)));
      }
    }
    throw lastError;
  };

  // Products are added a few at a time (one small batch per animation frame) so the
  // page never freezes while the rest of the collection loads – keeps taps responsive (INP).
  const LUX_BATCH = 24;
  // Yield to the browser between batches (a timer works in every tab state, unlike animation frames).
  const luxNextFrame = (fn) => setTimeout(fn, 0);

  const placeProduct = (state, node) => {
    if (node.dataset.available === 'true') {
      // In-stock products always go above the first out-of-stock one.
      if (state.firstOutOfStock && state.firstOutOfStock.parentNode === state.grid) {
        state.grid.insertBefore(node, state.firstOutOfStock);
      } else {
        state.grid.appendChild(node);
      }
    } else {
      state.grid.appendChild(node);
      if (!state.firstOutOfStock || state.firstOutOfStock.parentNode !== state.grid) state.firstOutOfStock = node;
    }
  };

  const pumpQueue = (state) => {
    if (state.pumping) return;
    state.pumping = true;
    const step = () => {
      if (!isCurrentLoader(state)) {
        state.queue.length = 0;
        state.pumping = false;
        if (state.onDrained) state.onDrained();
        return;
      }
      const batch = state.queue.splice(0, LUX_BATCH);
      batch.forEach((node) => placeProduct(state, node));
      if (state.queue.length) {
        luxNextFrame(step);
      } else {
        state.pumping = false;
        if (state.onDrained) state.onDrained();
      }
    };
    luxNextFrame(step);
  };

  const addProductsFromDoc = (state, doc) => {
    doc.querySelectorAll('#product-grid .lux-grid__item').forEach((item) => {
      const id = item.dataset.productId;
      if (state.known.has(id)) return;
      state.known.add(id);
      const node = document.importNode(item, true);
      node.classList.remove('scroll-trigger', 'animate--slide-in', 'animate--fade-in');
      node.removeAttribute('data-cascade');
      state.queue.push(node);
    });
    pumpQueue(state);
  };

  const waitForQueue = (state) => new Promise((resolve) => {
    if (!state.queue.length && !state.pumping) {
      resolve();
      return;
    }
    state.onDrained = () => {
      state.onDrained = null;
      resolve();
    };
  });

  const loadAllProducts = async (state) => {
    state.box.classList.add('is-loading');
    const ready = {};
    let nextToAdd = 2;
    const flush = () => {
      while (Object.prototype.hasOwnProperty.call(ready, nextToAdd)) {
        if (!isCurrentLoader(state)) return;
        if (ready[nextToAdd]) addProductsFromDoc(state, ready[nextToAdd]);
        delete ready[nextToAdd];
        nextToAdd += 1;
      }
    };
    try {
      const pages = [];
      for (let p = 2; p <= state.totalPages; p++) pages.push(p);
      await Promise.all(pages.map(async (p) => {
        try {
          ready[p] = await fetchProductPage(state, p);
        } catch (error) {
          ready[p] = null;
        }
        flush();
      }));
      await waitForQueue(state);
    } finally {
      state.box.classList.remove('is-loading');
      state.box.classList.add('is-done');
    }
  };

  const initLuxInfinite = () => {
    const box = document.querySelector('[data-lux-infinite]');
    const grid = document.querySelector('#product-grid');
    if (!box || !grid) {
      luxLoader = null;
      return;
    }
    // Already running on this exact DOM (no filter/sort change since).
    if (luxLoader && luxLoader.box === box && document.body.contains(box)) return;

    const params = new URLSearchParams(window.location.search);
    params.delete('page');
    params.delete('section_id');

    const items = Array.from(grid.querySelectorAll('.lux-grid__item'));
    const state = {
      box: box,
      grid: grid,
      params: params,
      sectionId: grid.dataset.id,
      totalPages: parseInt(box.dataset.pages || '1', 10),
      known: new Set(items.map((el) => el.dataset.productId)),
      firstOutOfStock: items.find((el) => el.dataset.available !== 'true') || null,
      queue: [],
      pumping: false,
      onDrained: null
    };
    luxLoader = state;

    // Start once the browser is idle so the first 250 products and the page itself stay responsive.
    const start = () => {
      if (isCurrentLoader(state) && state.totalPages > 1) loadAllProducts(state);
    };
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(start, { timeout: 1500 });
    } else {
      setTimeout(start, 300);
    }
  };

  // ── Debounced reinit after DOM mutations (filter/sort changes) ──────────────
  const scheduleReinit = () => {
    clearTimeout(reinitTimer);
    reinitTimer = setTimeout(() => {
      sortProductsByAvailability();
      initLuxInfinite();
      syncMobileFilterPlacement();
      bindFilterDrawerScrollFix();
      initDesktopSortDropdown();
      syncSortUIFromSelect();
      scheduleFloatingControlsVisibility();
    }, 80);
  };



  document.addEventListener('click', (event) => {
    const clickedInsideSort = event.target.closest('[data-sort]');
    if (!clickedInsideSort) {
      document.querySelectorAll('[data-sort].is-open').forEach((wrapper) => {
        closeDesktopSortDropdown(wrapper);
      });
    }

    const applyButton = event.target.closest('[data-lux-filter-apply]');
    if (applyButton) {
      submitFacets(collectSearchParams({ includeFilters: true, includeSort: true }));
      return;
    }

    const resetButton = event.target.closest('[data-lux-filter-reset]');
    if (resetButton) {
      submitFacets(collectSearchParams({ includeFilters: false, includeSort: true }));
      return;
    }

    if (event.target.closest('[data-mobile-filter-trigger]')) {
      openFilterDrawer();
      return;
    }

    if (event.target.closest('[data-mobile-sort-trigger]')) {
      openSortDrawer();
      return;
    }

    if (event.target.closest('[data-sort-drawer-close]')) {
      closeSortDrawer();
      return;
    }

    const mobileSortOption = event.target.closest('[data-mobile-sort-option]');
    if (mobileSortOption) {
      applySortValue(mobileSortOption.dataset.value);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeSortDrawer();
      document.querySelectorAll('[data-sort].is-open').forEach((wrapper) => {
        closeDesktopSortDropdown(wrapper);
      });
    }
  });

  const gridContainer = document.getElementById('ProductGridContainer');
  if (gridContainer) {
    const mutationObserver = new MutationObserver(scheduleReinit);
    mutationObserver.observe(gridContainer, { childList: true, subtree: true });
  }

  window.addEventListener('resize', () => {
    syncMobileFilterPlacement();
    if (!mobileQuery.matches) closeSortDrawer(true);
    scheduleFloatingControlsVisibility();
  });

  window.addEventListener('scroll', scheduleFloatingControlsVisibility, { passive: true });

  syncMobileFilterPlacement();
  bindFilterDrawerScrollFix();
  initDesktopSortDropdown();
  syncSortUIFromSelect();
  sortProductsByAvailability();
  initLuxInfinite();
  scheduleFloatingControlsVisibility();
});

